export default { sha: '0f4d67ff8774e3454a4e3ff4d56325ca07c3a544', buildNumber: 'undefined' }
